document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(".wp-block-create-block-cityprop-ajax-objects").forEach(block => {
        const currentData = { page: 1, order: 'price_asc', queryChanged: false, url: '', appendQuery: true };

        showPosts();
        var nextPage = block.getAttribute('data-next-page');
        var hasMorePages = block.getAttribute('data-has-more-pages');

        if (nextPage) {
            currentData.nextPage = nextPage;
        }

        if (hasMorePages) {
            currentData.hasMorePages = hasMorePages;
        }

        bindEventHandlers();
        bindLoadMoreObserver();
        let debounceTimer;

        function bindEventHandlers() {
            document.addEventListener("cp-ajax-objects-filters", (e) => {
                var formData = e.detail?.formData;
                var extraParams = e.detail?.extraParams;
                var dontFetch = e.detail?.dontFetch;

                currentData.formData = formData;
                currentData.queryChanged = true;
                currentData.page = 1;
                currentData.extraParams = extraParams;
                currentData.appendQuery = false;

                fetchPostsAsync(dontFetch, 0);
            });

            block.querySelectorAll("select").forEach((elem) => {
                new TomSelect(elem, {
                    onChange: (value) => {
                        currentData.order = value;
                        currentData.page = 1;
                        currentData.appendQuery = false;

                        fetchPostsAsync();
                    },
                    plugins: ['dropdown_input']
                });
            })

            block.classList.add("loaded");

            var showFilters = block.querySelector(".show-filters");
            var filtersContainer = document.querySelector(".cp-filters-container");
            if (showFilters) {
                showFilters.addEventListener("click", function() {
                    if (filtersContainer && !filtersContainer.classList.contains("open")) {
                        filtersContainer.classList.add("open");
                        
                        setFiltersFormWrapperHeight();
                    }
                });
            }
        }

        function fetchPostsAsync(dontFetch, scrollPosition) {
            var formData = currentData.formData;

            formData.set("order", currentData.order);

            var urlParams = [currentData.extraParams, new URLSearchParams(formData).toString()].join("&");

            const newURL = window.location.origin + window.location.pathname + "?" + urlParams;

            history.pushState({}, "", newURL);
            
            if (dontFetch) {
                return;
            }

            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(() => {
                fetchPosts(scrollPosition);
            }, 500);
        }

        function bindLoadMoreObserver() {
            var loadMore = document.querySelector("#cityprop-ajax-objects-load-more");
            if (!loadMore) {
                return;
            }

            var objectObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let scrollPosition = window.scrollY;
                        objectObserver.unobserve(entry.target);
                        if (currentData.nextPage) {
                            currentData.page = currentData.nextPage;
                            currentData.appendQuery = true;
                            
                            fetchPostsAsync(false, scrollPosition);
                        }
                    }
                });
            }, {});
            objectObserver.observe(loadMore);
        }

        function fetchPosts(scrollPosition) {
            const postsContainer = block.querySelector('.city-prop-ajax-objects-container');
            const noResultsContainer = block.querySelector('.cp-ajax-objects-not-found');
            const loaderContainer = block.querySelector('.city-prop-loader');
            const formData = currentData.formData;

            const xhr = new XMLHttpRequest();
            xhr.open('POST', ajaxData.ajax_url, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

            xhr.onload = function () {
                //loaderContainer.style.display = "none";
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    if (response.success) {
                        currentData.page = response.data.page;
                        currentData.hasMorePages = response.data.hasMorePages;
                        currentData.nextPage = response.data.nextPage;

                        var postsContainerWrapper = postsContainer.querySelector(".cp-ajax-objects-wrapper");

                        if (currentData.appendQuery && postsContainerWrapper) {
                            postsContainerWrapper.insertAdjacentHTML("beforeend", response.data.html);
                            bindLoadMoreObserver();
                        } else {
                            postsContainer.innerHTML = response.data.html;
                        }
                        setTimeout(showPosts, 10);
                        
                        if (Number.isFinite(parseInt(scrollPosition))) {
                            window.scrollTo(0, scrollPosition);
                        }
                        noResultsContainer.classList.remove("show");
                    } else {
                        postsContainer.innerHTML = '';
                        noResultsContainer.classList.add("show");
                    }
                } else {
                    console.error('Error fetching posts:', xhr.statusText);
                }
            };

            const params = { action: 'cityprop_fetch_posts', security: ajaxData.nonce, noWrapper: currentData.appendQuery, currentPage: currentData.page };

            loaderContainer.style.display = "block";
            xhr.send(buildQueryStringWithNested(params, formData));
        }

        function showPosts() {
            block.querySelectorAll(".cp-object-card-wrapper").forEach(card => {
                if (card.classList.contains("visible")) {

                } else {
                    card.classList.add("visible");
                }
            })
        }

        function buildQueryStringWithNested(params, formData, prefix = '') {
            var params = new URLSearchParams(params);

            for (let [key, value] of formData) {
                if (params.has(key)) {
                    params.append(key, value);
                } else {
                    params.set(key, value);
                }
            }
            return params;
        }

        function debounce(func, delay) {
            let timer;
            return function () {
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(this, arguments), delay);
            };
        }
    });
});
